import DesktopTableInlineBody from "./DesktopTableInlineBody";
import DesktopTableInlineHeader from "./DesktopTableInlineHeader";

const DesktopTableInlineActions = ({
  columns,
  data,
  actions,
  noDataMessage = "No hay registros disponibles.",
}) => {
  return (
    <div className="w-full overflow-x-auto rounded-xl border border-stroke bg-white shadow-1 dark:border-strokedark dark:bg-boxdark">
      <table className="w-full table-auto border-collapse min-w-[800px]">
        <DesktopTableInlineHeader columns={columns} hasActions={!!actions} />
        <DesktopTableInlineBody
          data={data}
          columns={columns}
          actions={actions}
          noDataMessage={noDataMessage}
        />
      </table>
    </div>
  );
};

export default DesktopTableInlineActions;
